// Shared page header primitive (FRONTEND-BLUEPRINT round-1 contract) — title + optional description +
// actions slot + an optional contextual-help "?" affordance (P3, legacy Privacy-Manager parity). `help` is a
// resolved string (caller passes t("help.<screen>")), keeping this component i18n-agnostic like title/description.
import type { ReactNode } from "react";
import { CircleHelp } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

export function PageHeader({ title, description, actions, help }: { title: string; description?: string; actions?: ReactNode; help?: string }) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
      <div>
        <div className="flex items-center gap-1.5">
          <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
          {help && (
            <Tooltip>
              <TooltipTrigger asChild>
                <Button type="button" variant="ghost" size="icon-xs" className="text-muted-foreground" aria-label={help}>
                  <CircleHelp className="size-4" />
                </Button>
              </TooltipTrigger>
              <TooltipContent side="right" className="max-w-xs whitespace-normal text-left">{help}</TooltipContent>
            </Tooltip>
          )}
        </div>
        {description && <p className="mt-1 text-sm text-muted-foreground">{description}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
